import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'
import Layout from '../layout/layout.vue'
import Login from '../views/login/Login.vue'
import CALogin from '../views/login/CALogin.vue'

Vue.use(VueRouter)

const routes = [

  // 缺省
  {
    path: '/',
    name: '登录',
    icoCls: 'home',
    redirect: '/calogin' ,
    hidden: true
  },

  //上海市统一身份认证CA认证
  {
    path: '/calogin',
    name: 'CA认证',
    icoCls: 'home',
    component: CALogin,
    hidden: true
  },

  // 登录路由
  // {
  //   path: '/login',
  //   name: '登录',
  //   icoCls: 'home',
  //   component: Login,
  //   hidden: true
  // },
  // 布局页
  {
    path: '/layout',
    name: '布局页',
    icoCls: 'home',
    component: Layout,
    hidden: true,
  },

]

const router = new VueRouter({
  mode: "history",
  routes
})

export default router
